// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V15H22V2ZM16.5 7L12.0001 11.5L7.5 7H16.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22V17H2V22H22Z"}}]};

const ExpandDownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'expand-down-filled',
    ref,
    icon: element,
  },
));

ExpandDownFilledIcon.displayName = 'ExpandDownFilledIcon';

export default ExpandDownFilledIcon;
